module.exports = __webpack_public_path__ + "static/media/foz-do-iguacu-pr.f4bb1482.jpg";